const { getNumericValueWithDecimals } = require('../../analyticUtils');
const { analyticsEventCenter, ANALYTICS_EVENTS } = require('../../events');
const { createCustomEventGA4 } = require('../models/customEventGA4');
const { createEcommerceEventGA4 } = require('../models/ecommerceEventGA4');
const { createEcommerceEventItemsGA4 } = require('../models/ecommerceEventItemsGA4');
const pushEvent = require('../pushEvent');

/* -------------------------------------------------------------------------- *\
 * PDP EVENTS                                                                 *
 * ----------                                                                 *
 * - Item Clicked                                                             *
 * - Product Details Viewed                                                   *
\* -------------------------------------------------------------------------- */

/**
 * Subscribe to our analytics events and push to dataLayers
 */
function subscribeToAnalyticsEvents() {
  // Item Clicked
  analyticsEventCenter.subscribe(ANALYTICS_EVENTS.productDetailsItemClicked, (item) => {
    pushEvent(
      createCustomEventGA4('product_info', [
        ['action', 'click'],
        ['item', item],
      ]),
    );
  });

  // Product Details Viewed
  analyticsEventCenter.subscribe(ANALYTICS_EVENTS.productDetailsViewed, (payload) => {
    const productData = ({
      ...payload.product,
      itemProps: {
        product_id_with_size: undefined,
        searched_term: payload.searchData?.query || undefined,
      },
    });
    pushEvent(
      createEcommerceEventGA4('view_item',
        createEcommerceEventItemsGA4([productData]),
        {
          currency: gaInfo.currencyCode,
          value: getNumericValueWithDecimals(
            payload.product?.price?.sales?.decimalPrice,
          ),
        }),
    );
  });
}

module.exports = {
  subscribeToAnalyticsEvents,
};
